export class QuizApp {
  constructor() {
    let _this = this;
    this.quizData = [
      {
        id: 1,
        question: _t("Have you used SimplyBook.me before?"),
        answers: [
          { answer_id: "a", text: _t("I don’t have a SimplyBook.me account yet"), next: 2 },
          { answer_id: "b", text: _t("I just signed up for a free trial"), next: 2 },
          { answer_id: "c", text: _t("I’ve been using SimplyBook.me for a while"), next: 4 },
        ],
      },
      {
        id: 2,
        question: _t("Which of the following best describes your business?"),
        answers: [
          { answer_id: "a", text: _t("We’re an established company"), next: 3 },
          { answer_id: "b", text: _t("We have a franchise network"), next: 6 },
          { answer_id: "c", text: _t("We’re a startup"), next: "widget2" },
          { answer_id: "d", text: _t("We’re a group of freelancers"), next: "widget2" },
          { answer_id: "e", text: _t("We’re interested in a partnership or affiliate program"), next: "widget5" },
          { answer_id: "f", text: _t("We’re a marketplace"), next: "widget2" },
          { answer_id: "g", text: _t("None of the above"), next: "widget3" },
        ],
      },
      {
        id: 3,
        question: _t("How many team members do you plan to have on the system?"),
        answers: [
          { answer_id: "a", text: _t("1–30"), next: 4 },
          { answer_id: "b", text: _t("31–60"), next: 4 },
          { answer_id: "c", text: _t("61–250"), next: 7 },
          { answer_id: "d", text: _t("251 or more"), next: 7 },
        ],
      },
      {
        id: 4,
        question: _t("What’s the main purpose of your meeting?"),
        answers: [
          { answer_id: "a", text: _t("I’m interested in the Enterprise solution"), next: 5 },
          { answer_id: "b", text: _t("I’d like paid CSS assistance"), next: "widget1" },
          { answer_id: "c", text: _t("I’d like paid assistance with an account manager"), next: "widget1" },
          { answer_id: "d", text: _t("I need a demo session"), next: "widget2" },
          { answer_id: "e", text: _t("I have 1–2 quick setup questions"), next: "widget3" },
        ],
      },
      {
        id: 5,
        question: _t("What’s your approximate budget for this project?"),
        answers: [
          { answer_id: "a", text: _t("More than $6,000 annually"), next: "widget4" },
          { answer_id: "b", text: _t("More than $12,000 annually"), next: "widget4" },
          { answer_id: "c", text: _t("More than $20,000 annually"), next: "widget4" },
          { answer_id: "d", text: _t("Less than $6,000 annually"), next: "widget2" },
        ],
      },
      // хз нащо це і як сюди попасти, але дівчати дуже хочуть, комент від Іри:
      // ми типу будемо під кожен кейс мати окремий сервіс
      // в нас нема можливості відповіді клієнта передавати в букінг відповідно
      // щоб хоч якось знати що він відповів ми мусимо зробити три сервіси,
      // хоч всі вони будуть ентерпрайз сервісами
      {
        id: 6,
        question: _t("What’s your approximate budget for this project?"),
        answers: [
          { answer_id: "a", text: _t("More than $6,000 annually"), next: "widget6" },
          { answer_id: "b", text: _t("More than $12,000 annually"), next: "widget6" },
          { answer_id: "c", text: _t("More than $20,000 annually"), next: "widget6" },
          { answer_id: "d", text: _t("Less than $6,000 annually"), next: "widget2" },
        ],
      },
      {
        id: 7,
        question: _t("What’s your approximate budget for this project?"),
        answers: [
          { answer_id: "a", text: _t("More than $6,000 annually"), next: "widget7" },
          { answer_id: "b", text: _t("More than $12,000 annually"), next: "widget7" },
          { answer_id: "c", text: _t("More than $20,000 annually"), next: "widget7" },
          { answer_id: "d", text: _t("Less than $6,000 annually"), next: "widget2" },
        ],
      },
    ];
    this.widgets = {
      // For answer B, C in Q4;
      widget1: {
        title: _t("Setup evaluation with SimplyBook.me, please wait while the widget opens."),
        action: function () {
          const lang = document.documentElement.getAttribute("lang");

          // Додаємо перевірку для скорочених та повних назв мов
          switch (true) {
            case lang.startsWith("en"):
              _this.createServiceIdInWidget(3); // English
              break;
            default:
              _this.createServiceIdInWidget(3);
          }

          setTimeout(() => {
            document.querySelector("#sb_enterprise_widget").click();

            document.getElementsByClassName("result-section_title")[0].classList.add("hide");

            _this.closeRoutingFormPopup();
          }, 2000);
        },
      },

      // For answer D, E, F in Q2;
      // For answer D in Q4;
      // For answer D. in Q5:
      // For answer D. in Q6:
      // For answer D. in Q7:
      widget2: {
        title: _t("Demo call with SimplyBook.me: please wait while the widget opens."),
        //link: "https://bigaccounts.simplybook.it/v2/#book/service/52"
        action: function () {
          _this.createServiceIdInWidget(52);

          setTimeout(() => {
            document.querySelector("#sb_enterprise_widget").click();

            document.getElementsByClassName("result-section_title")[0].classList.add("hide");

            _this.closeRoutingFormPopup();
          }, 2000);
        },
      },
      // For answer E in Q4;
      widget3: {
        title: _t("LiveChat with Support Team, please wait while the widget opens."),
        content:
          `<a href="https://www.youtube.com/watch?v=TdvpW6XiuW8&list=PLM9QxGer1Y2qTVNQp5n3mNFI6tw_iNf3Y" target="_blank" id="sb-tutorials-link" class=" btn btn--secondary btn-icon-left fa-youtube">` +
          _t("New user onboarding tutorials") +
          `</a>`,
        action: function () {
          // console.log('LiveChat with Support Team');
          setTimeout(() => {
            // Додаємо фолбек на випадок відсутності елемента
            const chatTrigger = document.getElementById("trigger_support_chat");
            if (chatTrigger) {
              chatTrigger.click();

              document.getElementsByClassName("result-section_title")[0].classList.add("hide");

              //closeRoutingFormPopup();
            } else {
              // console.warn('Chat trigger element not found');
              alert(_t('Please click the "Open Live Chat" button to start chat.'));
            }
          }, 1600);

          document.addEventListener("click", function (event) {
            if (event.target.closest("#sb-tutorials-link")) {
              //('close popup');
              _this.closeRoutingFormPopup();
            }
          });
        },
      },

      // For answer A, B, C in Q5
      widget4: {
        title: _t("Enterprise inquiry with SimplyBook.me, please wait while the widget opens."),
        action: function () {
          const lang = document.documentElement.getAttribute("lang");

          // Додаємо перевірку для скорочених та повних назв мов
          switch (true) {
            case lang.startsWith("en"): // English
              _this.createServiceIdInWidget(53);
              break;
            case lang.startsWith("fr"): // Français
              _this.createServiceIdInWidget(55);
              break;
            case lang.startsWith("es"): // Español
              _this.createServiceIdInWidget(54);
              break;
            case lang.startsWith("pt"): // Portuguese
              _this.createServiceIdInWidget(56);
              break;
            case lang.startsWith("zh-CN"): // Chinese
              _this.createServiceIdInWidget(57);
              break;
            default:
              _this.createServiceIdInWidget(1);
          }

          setTimeout(() => {
            document.querySelector("#sb_enterprise_widget").click();

            document.getElementsByClassName("result-section_title")[0].classList.add("hide");

            _this.closeRoutingFormPopup();
          }, 2000);
        },
      },

      // For answer C in Q2
      widget5: {
        title: _t("Partnership and affiliates, please wait while the widget opens."),
        //link: "https://bigaccounts.simplybook.it/v2/#book/service/14"
        action: function () {
          _this.createServiceIdInWidget(14);

          setTimeout(() => {
            document.querySelector("#sb_enterprise_widget").click();

            document.getElementsByClassName("result-section_title")[0].classList.add("hide");

            _this.closeRoutingFormPopup();
          }, 2000);
        },
      },

      // For answer A, B, C in Q6
      widget6: {
        title: _t("Category Enterprise inquiry with SimplyBook.me, please wait while the widget opens."),
        action: function () {
          const lang = document.documentElement.getAttribute("lang");

          // Додаємо перевірку для скорочених та повних назв мов
          switch (true) {
            case lang.startsWith("en"): // English
              _this.createServiceIdInWidget(53);
              break;
            case lang.startsWith("fr"): // Français
              _this.createServiceIdInWidget(60);
              break;
            case lang.startsWith("es"): // Español
              _this.createServiceIdInWidget(59);
              break;
            case lang.startsWith("pt"): // Portuguese
              _this.createServiceIdInWidget(62);
              break;
            case lang.startsWith("zh-CN"): // Chinese
              _this.createServiceIdInWidget(64);
              break;
            default:
              _this.createServiceIdInWidget(58);
          }

          setTimeout(() => {
            document.querySelector("#sb_enterprise_widget").click();

            document.getElementsByClassName("result-section_title")[0].classList.add("hide");

            _this.closeRoutingFormPopup();
          }, 2000);
        },
      },

      // For answer A, B, C in Q7
      widget7: {
        title: _t("Category Enterprise inquiry with SimplyBook.me, please wait while the widget opens."),
        action: function () {
          const lang = document.documentElement.getAttribute("lang");

          // Додаємо перевірку для скорочених та повних назв мов
          switch (true) {
            case lang.startsWith("en"): // English
              _this.createServiceIdInWidget(66);
              break;
            case lang.startsWith("fr"): // Français
              _this.createServiceIdInWidget(61);
              break;
            case lang.startsWith("es"): // Español
              _this.createServiceIdInWidget(67);
              break;
            case lang.startsWith("pt"): // Portuguese
              _this.createServiceIdInWidget(63);
              break;
            case lang.startsWith("zh-CN"): // Chinese
              _this.createServiceIdInWidget(65);
              break;
            default:
              _this.createServiceIdInWidget(66);
          }

          setTimeout(() => {
            document.querySelector("#sb_enterprise_widget").click();

            document.getElementsByClassName("result-section_title")[0].classList.add("hide");

            _this.closeRoutingFormPopup();
          }, 2000);
        },
      },
    };
    this.currentSlide = 0;
    this.userAnswers = {};
    this.totalSlides = 0;
    this.historyStack = [];
    this.hideTimeout = null;

    this.selectAnswer = this.selectAnswer.bind(this);
    this.handleAnswerClick = this.handleAnswerClick.bind(this);
  }

  init() {
    document.addEventListener("DOMContentLoaded", () => {
      //console.log('DOMContentLoaded, init QuizApp');

      this.setupEventListeners();
      this.setupSpionBird();
      this.initQuiz();
    });
  }

  setupEventListeners() {
    document.querySelector(".widget_btn")?.addEventListener("click", () => {
      //console.log("click");
      document.querySelector("#sb_enterprise_widget")?.click();
    });
  }

  setupSpionBird() {
    //console.log("setupSpionBird");
    this.btn = document.getElementById("prevBtn");
    this.birdVideo = document.getElementById("dance-bird");
    this.birdBox = document.querySelector(".bird-wrapper");
    this.birdEye = document.querySelector(".bird-eye");

    document.addEventListener("mousemove", (e) => this.handleMouseMove(e));

    this.btn?.addEventListener("mouseover", () => this.handleBirdHover());
    this.btn?.addEventListener("mouseout", () => this.handleBirdLeave());
  }

  handleMouseMove(event) {
    //console.log("handleMouseMove");
    const eyes = document.querySelectorAll(".eye");
    eyes.forEach((eye) => this.moveEye(eye, event));
  }

  moveEye(eye, event) {
    //console.log("moveEye");
    const eyeWrap = eye.closest(".eye-wrap");
    if (!eyeWrap) return;

    const rect = eyeWrap.getBoundingClientRect();
    const eyeCenterX = rect.left + rect.width / 2;
    const eyeCenterY = rect.top + rect.height / 2;

    const deltaX = event.clientX - eyeCenterX;
    const deltaY = event.clientY - eyeCenterY;
    const distance = Math.sqrt(deltaX ** 2 + deltaY ** 2) || 1;

    const maxMove = rect.width / 7;
    const scale = Math.min(maxMove / distance, 1);

    eye.style.transform = `translate(${deltaX * scale}px, ${deltaY * scale}px)`;
  }

  handleBirdHover() {
    //console.log("handleBirdHover");
    clearTimeout(this.hideTimeout);
    this.birdBox?.classList.add("_disagree");
    this.birdEye?.classList.add("hide");
    this.birdVideo?.play();
  }

  handleBirdLeave() {
    //console.log("handleBirdLeave");
    this.birdBox?.classList.remove("_disagree");
    this.hideTimeout = setTimeout(() => {
      this.birdEye?.classList.remove("hide");
      this.birdVideo?.pause();
    }, 2000);
  }

  initQuiz() {
    //console.log("initQuiz");
    const container = document.getElementById("slides-container");
    const loader = document.querySelector(".quiz-container--loader");

    if(container){
      this.quizData.forEach((question, index) => {
        container.appendChild(this.createSlide(question, index));
      });
    }

    this.totalSlides = document.querySelectorAll(".slide").length;
    this.updateProgress();
    this.initNavigation();

    loader?.classList.add("fadeOutLeft");
    setTimeout(() => loader?.remove(), 520);
  }

  createSlide(question, index) {
    // console.log("createSlide");
    const slide = document.createElement("div");
    slide.className = `animated slide ${index === 0 ? "fadeInRight active" : "fadeOutLeft"}`;
    slide.innerHTML = `
            <h3 class="title title--h3">${question.question}</h3>
            ${question.answers
              .map(
                (answer) => `
                <div class="answer-option--wrapper">
                    <b>${answer.answer_id}</b>
                    <div class="answer-option">${answer.text}</div>
                </div>
            `
              )
              .join("")}`;

    // Додаємо обробники подій
    slide.querySelectorAll(".answer-option--wrapper").forEach((option, i) => {
      option.addEventListener("click", (e) => this.handleAnswerClick(e, question, question.answers[i]));
    });

    return slide;
  }

  handleAnswerClick(event, question, answer) {
    //console.log("handleAnswerClick");
    this.selectAnswer(question.id, question.question, answer.answer_id, answer.text, answer.next);
  }

  selectAnswer(question_id, question, answer_id, answer_text, next) {
    //console.log("selectAnswer");
    this.historyStack.push(this.currentSlide);
    this.userAnswers[question_id] = { question, answer_id, answer_text, next };

    if (typeof next === "string" && next.startsWith("widget")) {
      this.showResult(next);
      return;
    }

    this.currentSlide = this.quizData.findIndex((q) => q.id === parseInt(next));
    this.showSlide(this.currentSlide);
    this.updateProgress();
  }

  showResult(widgetKey) {
    //console.log("showResult");
    const container = document.getElementById("slides-container");
    const resultSection = document.getElementById("result-section");

    container.style.display = "none";
    resultSection.style.display = "block";

    const widget = this.widgets[widgetKey];
    let content = "";

    if (widget.title) {
      content += `<h3 class="title result-section_title">${widget.title}</h3>`;
    }

    if (widget.content) {
      content += widget.content;
    }

    if (widget.action) {
      widget.action();
    }

    resultSection.innerHTML = content;
    this.updateProgress(100);

    this.autoPlayVideo(true);
    this.birdVideo?.play();
    this.birdEye?.classList.add("hide");

    document.getElementById("prevBtn").classList.add("hide"); // hide prev button
  }

  showSlide(index) {
    //console.log("showSlide");
    document.querySelectorAll(".slide").forEach((slide, i) => {
      slide.classList.toggle("active", i === index);
      slide.classList.toggle("fadeInRight", i === index);
      slide.classList.toggle("fadeOutLeft", i !== index && i < index);
    });
    this.updateButtons();
  }

  updateProgress(percent) {
    //console.log("updateProgress");
    const progressBar = document.querySelector(".progress");

    if (progressBar) {
      if (percent) {
        progressBar.style.width = `${percent}%`;
      } else {
        const progress = ((this.currentSlide + 1) / this.totalSlides) * 100;
        progressBar.style.width = `${progress}%`;
      }
    }
  }

  updateButtons() {
    //console.log("updateButtons");
    const prevBtn = document.getElementById("prevBtn");

    if(prevBtn) {
      prevBtn.disabled = this.currentSlide === 0;
      prevBtn.classList.toggle("hidden", this.currentSlide === 0);
    }
  }

  initNavigation() {
    document.getElementById("prevBtn")?.addEventListener("click", () => this.prevSlide());
    document.getElementById("nextBtn")?.addEventListener("click", () => this.nextSlide());
  }

  nextSlide() {
    if (this.currentSlide < this.totalSlides - 1) {
      this.currentSlide++;
      this.showSlide(this.currentSlide);
      this.updateProgress();
    }
  }

  prevSlide() {
    if (this.historyStack.length > 0) {
      const previousSlide = this.historyStack.pop();
      this.currentSlide = previousSlide;
      this.showSlide(this.currentSlide);
      this.updateProgress();
    }
  }

  autoPlayVideo(play) {
    if (!this.birdVideo) return;

    if (play) {
      this.birdVideo.setAttribute("loop", "");
      this.birdVideo.setAttribute("muted", "");
      this.birdVideo.setAttribute("autoplay", "");
      this.birdVideo.setAttribute("playsinline", "");
    } else {
      this.birdVideo.removeAttribute("loop");
      this.birdVideo.removeAttribute("muted");
      this.birdVideo.removeAttribute("autoplay");
      this.birdVideo.removeAttribute("playsinline");
    }
  }

  closeRoutingFormPopup() {
    //console.log("closeRoutingFormPopup");
    const routingPopup = $("#routing-form__popup");
    routingPopup?.modal("hide");
  }

  createServiceIdInWidget(newServiceId) {
    //console.log("createServiceIdInWidget");
    new SimplybookWidget({
      widget_user_class: "enterprise-widget enterprise-widget__white",
      button_custom_id: "sb_enterprise_widget",
      widget_type: "button",
      url: "https://bigaccounts.simplybook.it",
      theme: "creative",
      theme_settings: {
        sb_base_color: "#06adef",
        timeline_show_end_time: "0",
        timeline_modern_display: "as_slots",
        dark_font_color: "#474747",
        light_font_color: "#ffffff",
        hide_img_mode: "1",
        sb_busy: "#dad2ce",
        sb_available: "#d3e0f1",
      },
      timeline: "modern",
      datepicker: "inline_datepicker",
      is_rtl: false,
      app_config: {
        predefined: {
          service: newServiceId,
        },
      },
    });
  }
}